import { defineEvent } from '../types/event';
export var CUSTOMER_LOGIN = defineEvent({
    platforms: [
        {
            name: 'Heap',
            alias: 'customerLogin'
        },
        {
            name: 'GTM',
            alias: 'customerLogin'
        }
    ]
});
